var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"container-full btn-big",attrs:{"disabled":_vm.demand && _vm.demand.status != _vm.statuses.EMPTY && _vm.demand.status != _vm.statuses.RESULT},on:{"click":_vm.order}},[_vm._v(_vm._s(_vm.$t('offsettingcommon.order')))])}
var staticRenderFns = []

export { render, staticRenderFns }